<template>
  <va-edit-layout>
    <user-form :id="id" :title="title" :item="item"></user-form>
  </va-edit-layout>
</template>

<script>
export default {
  props: ["id", "title", "item"],
};
</script>
